import React from 'react';

import { useStyles } from './useStyles';

export const Aisle = ({ seat, maxWidth, widthJoinAisle }) => {
    const classes = useStyles(maxWidth, widthJoinAisle)();

    return (
        <article key={`aisle_${seat.id}`} className={classes.aisle}>
            <span>{seat.row}</span>
        </article>
    );
};
